import jsonp from 'jsonp'
import queryString from 'querystring'

const namespace = 'https://vw-klub.us16.list-manage.com/subscribe/post-json'

const submit = (body, cb, errorCb) => {
    jsonp(namespace + '?' + queryString.stringify(body), null)
}

export {
    submit
}



// WEBPACK FOOTER //
// ./src/services/register/registerService.js